import { defineMessages } from 'react-intl';

import { fieldNames } from './model';

export const labels = defineMessages({
  [fieldNames.acceptTermsAndConditions]: {
    id: `auth.consent.fields.acceptTermsAndCondition.label`,
    defaultMessage: 'By checking this box, I confirm that I have read and agree to the {privacy}.',
  },
});

export const header = defineMessages({
  title: {
    id: 'auth.consent.header.title',
    defaultMessage: 'Privacy Policy',
  },
});

export const content = defineMessages({
  declarationTitle: {
    id: 'auth.consent.content.declaration.title',
    defaultMessage: 'Declaration',
  },
  declarationContentOne: {
    id: 'auth.consent.content.declaration.contentOne',
    defaultMessage:
      'I affirm that all the information given in this application is true and accurate to the best of my knowledge. I understand that I will be liable for withdrawal from my course without refund of fees if I am admitted on the basis of any false or inaccurate information.',
  },
  declarationContentTwo: {
    id: 'auth.consent.content.declaration.contentTwo',
    defaultMessage:
      'I agree to abide by the decision of the Polytechnic concerning the application. I will take full responsibility in safeguarding the details of this application (such as keeping my password confidential), and will bear any consequences resulting from my failure to do so.',
  },
  declarationContentThree: {
    id: 'auth.consent.content.declaration.contentThree',
    defaultMessage:
      'The Polytechnic reserves the right to discontinue any class, to alter courses, course curricula and requirements, amend the scale of fees and update any other information without prior notice. Acceptance of an application does not imply any commitment to admit the applicant. Decision of the Polytechnic is final.',
  },
  declarationContentFour: {
    id: 'auth.consent.content.declaration.contentFour',
    defaultMessage:
      'I hereby consent to the Polytechnic’s use or disclosure of any information relating to me or my application, to third parties, as the Polytechnic deems fit in its absolute discretion.',
  },
  declarationContentFive: {
    id: 'auth.consent.content.declaration.contentFive',
    defaultMessage:
      'I understand that the Polytechnic may share necessary data with other Government agencies, so as to serve me in the most efficient and effective way unless such sharing is prohibited by law. The Polytechnic will not share my Personal Data with non-Government entities, except where such entities have been authorised to carry out specific Government services.',
  },
  termsOfUseTitle: {
    id: 'auth.consent.content.terms.title',
    defaultMessage: 'Terms of Use (Privacy statement)',
  },
  termsOfUseContent: {
    id: 'auth.consent.content.terms.content',
    defaultMessage:
      'GoSchool and Ngee Ann Polytechnic will take reasonable steps to protect your data from unauthorised disclosure. Data will be securely disposed of when the purpose has been met. For more information please visit: {privacy}',
  },
  chooseToDelete: {
    id: 'auth.consent.content.chooseToDelete',
    defaultMessage: 'Or you can choose to {link} your account.',
  },
});

export const buttons = defineMessages({
  submit: {
    id: 'auth.consent.buttons.submit',
    defaultMessage: 'Continue',
  },
  delete: {
    id: 'auth.consent.buttons.delete',
    defaultMessage: 'here',
  },
});



// WEBPACK FOOTER //
// ./src/ui/auth/consent/messages.js